/**
 * @desc 根据sku编号查询sku简要信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuBriefDetailResponseRpcDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuBriefBySkuNo/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
